import React, { useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleEditMode } from 'actions/editor';

import _ from 'lodash';
import cx from 'classnames';

import { EditorContext } from '../../index';
import { FORM, HOTSPOT } from 'constants/widgetTypes';

import { Property } from '../../components/properties/';
import { ButtonWidgetMobileAction, ButtonStyleEditor, ButtonTextEditor } from '../button';
import styles from '../button/button.module.scss';

const OtpResendButtonWidget = {};

OtpResendButtonWidget.moveableConfig = (editorSession, widget) => {
  const widgetElement = document.querySelector(`#${editorSession} .editor_widget_renderer #${widget.uid}`);
  const formElement = widgetElement?.closest(`div[data-widget-type="${FORM}"]`);  
  const pageElement = widgetElement?.closest(`.editor_widget_scroll_container`);

  const rect = formElement?.getBoundingClientRect();
  const parentRect = pageElement?.getBoundingClientRect();

  const left = rect?.left - parentRect?.left;
  const top = pageElement?.scrollTop + rect?.top - parentRect?.top;

  const bounds = { 
    left: left, 
    right: left + rect?.width, 
    top: top, 
    bottom: top + rect?.height
  }

  return {
    draggable: true,
    resizable: true,
    rotatable: true,
    selectable: true,
    cloneable: false,
    deletable: false,
    renderDirections: ['e', 'w', 's'],
    bounds: bounds,
    onReparent: () => {
      return false
    }
  }
}

const OtpResendButtonWidgetDesktopAction = (props) => {
  const dispatch = useDispatch();

  const [view, setView] = useState(null);

  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;

  const id = _.get(props, 'uid');
  const editMode = useSelector(state => {
    return _.get(state, `${editorSession}.present.editMode`) === id
  });

  const handleEditMode = () => {
    dispatch(toggleEditMode(editorSession, props.uid, true));
    setView(null);
  }

  const changeView = (view) => {
    dispatch(toggleEditMode(editorSession, props.uid, false));
    setView(view);
  }

  const closePopup = () => {
    dispatch(toggleEditMode(editorSession, props.uid, false));
    setView(null);
  }

  return (
    <>
      <Property.Action className={styles.textButton} onClick={handleEditMode.bind(this, 'text')}>Change Text</Property.Action>
      <Property.Divider />
      <Property.Action className={styles.iconButton} tooltip='Style' onClick={() => changeView('style')}>
        <i className={cx("cleverstory-customize")} />
      </Property.Action>
      <Property.Action className={styles.iconButton} tooltip='Help' onClick={() => { window.open(`${process.env.REACT_APP_CLEVERSTORY_SUPPORT}`, '_blank') }}>
        <i className={'cleverstory-help'} />
      </Property.Action>

      {editMode &&
        <ButtonTextEditor
          id={id}
          editor={editorSession}
          widget={props}
          onCancel={() => {
            closePopup()
          }}
        />
      }

      {!editMode && view === 'style' &&
        <ButtonStyleEditor
          editor={editorSession}
          widgets={[props]}
          onCancel={() => {
            closePopup()
          }}
        />
      }
    </>
  );
}

OtpResendButtonWidget.actions = (editor, breakpoint, props) => {
  return (
    <>
      {breakpoint === 'desktop' &&
        <OtpResendButtonWidgetDesktopAction editorSession={editor} breakpoint={breakpoint} {...props} />
      }

      {breakpoint === 'mobile' &&
        <ButtonWidgetMobileAction editorSession={editor} breakpoint={breakpoint} {...props} showAnimation={false} />
      }
    </>
  );
}

OtpResendButtonWidget.processRequest = (widget) => {
  return widget;
}

export { OtpResendButtonWidget };